import styled from "styled-components";
import { theme } from "theme/theme";

export const StyledDecimals = styled.div`
    border-bottom: 1px solid ${theme.colors.fieldBorder};
    padding: 12px;
    width: 100%;
    justify-content: flex-start;
    font-size: 14px;
    line-height: 21px;

    span {
      margin-left: auto;
      font-size: 12px;
      font-weight: 500;
      color: ${theme.colors.textDisabled};
    }
  `;